module.exports = __webpack_public_path__ + "media/images/brand/logo-07-6fcc9867c3a770f308670331ed51c65d.png";